// @flow

import messages from '../messages';

const HALF = { xs: 12, sm: 6 };

// No validation rules: the backend applies every Tour Blockout rule and the
// form shows its answer on the field it names. Checks here would stop a rule
// from ever reaching the backend.
export const buildFields = (intl: Object): Array<Object> => [
  {
    variant: 'dateTime',
    name: 'startTime',
    label: intl.formatMessage(messages.start),
    GridProps: HALF,
  },
  {
    variant: 'dateTime',
    name: 'endTime',
    label: intl.formatMessage(messages.end),
    GridProps: HALF,
  },
  {
    variant: 'text',
    name: 'label',
    label: intl.formatMessage(messages.label),
    GridProps: HALF,
  },
  {
    variant: 'number',
    name: 'slotsBlocked',
    label: intl.formatMessage(messages.slotsBlocked),
    placeholder: '',
    GridProps: HALF,
  },
];
